import { useSyncExternalStore } from "react";

// `data-theme` on <html> is kept in sync by the boot script and ThemeProvider,
// so it already reflects system mode and live OS preference changes.
function getResolvedColorScheme(): "light" | "dark" {
  return document.documentElement.getAttribute("data-theme") === "dark"
    ? "dark"
    : "light";
}

function subscribe(onChange: () => void): () => void {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["data-theme"],
  });
  return () => observer.disconnect();
}

// Use when a vendor widget needs the concrete theme rather than the raw
// preference, which may be "system".
export function useResolvedColorScheme(): "light" | "dark" {
  return useSyncExternalStore(subscribe, getResolvedColorScheme);
}
